import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "join-team-wrapper" }
const _hoisted_2 = { class: "tips" }


const __default__ = {
  name: 'JoinTeam'
}

import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n'

// 判断是否登录
import useTeamShare from '@teams/common/hooks/useTeamShare'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { settingInfo } = useTeamShare()

const { t } = useI18n()
// eslint-disable-next-line
const $tt = (key: string, ...params: any[]) => {
  // @ts-ignore
  return t(`components.dialog.joinTeam.${key}`, ...params)
}
const needApprove = computed(() => {
  return settingInfo.value.share_need_approve
})
const i18n = reactive({
  tips: computed(() => {
    return needApprove.value ? $tt('tipsNeedApprove') : $tt('tips')
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(i18n.tips), 1)
  ]))
}
}

})